import React from 'react';
import { compose, pure } from 'recompose';
// import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';

// const styles = {};

const enhance = compose(pure);

const CouponTableBody = enhance(
  ({ coupons, emptyRows, page, rowsPerPage, setListCoupon }) => {
    console.log('xxx', coupons);
    return (
      <TableBody>
        {coupons &&
          coupons
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((result, index) => {
              return (
                <TableRow key={result.couponId}>
                  <TableCell>
                    <Checkbox
                      color="primary"
                      onChange={() => {
                        setListCoupon(result.couponId);
                      }}
                    />
                  </TableCell>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{result.couponId}</TableCell>
                  <TableCell>{result.menuId}</TableCell>
                  <TableCell>{result.menuName}</TableCell>
                  <TableCell>{result.amount}</TableCell>
                  <TableCell>{result.taxAmount}</TableCell>
                  <TableCell>{result.createdAt}</TableCell>
                  <TableCell>{result.gochiUserEmail}</TableCell>
                  <TableCell>{result.useDate}</TableCell>
                  <TableCell>{result.userForShopName}</TableCell>
                </TableRow>
              );
            })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={13} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default CouponTableBody;
